import { reuseTypes } from './parameters';
import { modelVersionKeys, modelVersions } from './constants';
import { callApi } from './general';
import { issetInputValue } from '../components/ModelView/utils';
import { parseFloatInput } from '../helpers/input';
import { analysisColumnKeys } from '../store/constants';

const extractParameter = (obj, param, skipEmpty = true) =>
    Object.entries(obj).reduce((prev, [key, value]) => {
        if (!issetInputValue(value[param])) {
            if (skipEmpty) {
                return prev;
            }
            return {
                ...prev,
                [key]: 0.0,
            };
        }
        return {
            ...prev,
            [key]: parseFloatInput(value[param]),
        };
    }, {});

export const outputColumns = {
    advies: 'advies', // model output
    svo: 'SVO', // standard recipe
    verschil: 'verschil', // adjustments
    supply: 'supply', // ??
    matstreef: 'matstreef', // ??
};

export const runModel = (modelVersion, key, parameters) => {
    return new Promise((resolve, reject) => {
        const { useDrainAnalysis } = parameters;

        const modelParameters = {};
        modelParameters.userproperties = {
            crop: parameters.crop,
            teeltfase: parameters.stage,
            chlorine: parameters.chlorine,
            hergebruik: parameters.reuseDrainwater.reuse,
            // // vast_meng: parameters.reuseDrainwater.reuseType === reuseTypes.fixed,
            'meng%': parseFloatInput(
                parameters.reuseDrainwater.fixedPercentage
            ),
            EC_regeling: parameters.reuseDrainwater.reuseType === reuseTypes.EC,
            'EC%': parseFloatInput(parameters.reuseDrainwater.EC),
            'Gewenste EC': parseFloatInput(parameters.dropWaterValue),

            // ph_feed: parameters.ionValues.pH["feedWaterAnalysis"],
            // ph_mat: parameters.ionValues.pH["drainAnalysis"],
            // // ph_drain: parameters.ionValues.pH["drainAnalysis"],
            // EC_feed: parameters.ionValues.EC["feedWaterAnalysis"],
            // EC_mat: parameters.ionValues.EC["drainAnalysis"],
            // // ureum: parameters.ureum.used,
            // // "ureum%": parameters.ureum.percentage,
        };

        if (modelVersion === modelVersions.substraat) {
            modelParameters.userproperties.substraat = parameters.substrate;

            modelParameters.mat_meting = extractParameter(
                parameters.ionValues,
                'drainAnalysis'
            );
        }

        modelParameters.feed_water = extractParameter(
            parameters.ionValues,
            'feedWaterAnalysis',
            false
        );

        if (modelVersion === modelVersions.potplant) {
            if (useDrainAnalysis) {
                modelParameters.drain_meting = extractParameter(
                    parameters.ionValues,
                    'drainAnalysis',
                    false
                );
                console.warn(
                    'Temporary hack to run model, drain drain_meting copied to mat_meting!'
                );
                modelParameters.mat_meting = modelParameters.drain_meting;
            } else {
                modelParameters.mat_meting = extractParameter(
                    parameters.ionValues,
                    analysisColumnKeys.oneToOneDotFive,
                    false
                );
                console.warn(
                    'Temporary hack to run model, drain drain_meting copied to mat_meting!'
                );
                modelParameters.drain_meting = modelParameters.mat_meting;
            }

            modelParameters.userproperties.ureum = parameters.ureum.used;
            if (parameters.ureum.used) {
                modelParameters.userproperties['ureum%'] =
                    parameters.ureum.percentage;
                modelParameters.userproperties.ureum_drain =
                    parameters.ureum.drain;
            } else {
                modelParameters.userproperties['ureum%'] =
                    parameters.ureum.percentage || 0;
                modelParameters.userproperties.ureum_drain =
                    parameters.ureum.drain || 0;
            }
            modelParameters.userproperties.z_w = parameters.summerWinter;
            // modelParameters.userproperties.ph_mat =
            //     modelParameters.mat_meting.pH;
            // modelParameters.userproperties.ph_drain =
            //     modelParameters.drain_meting.pH;
            // modelParameters.userproperties.ph_feed =
            //     modelParameters.feed_water.pH;
        }

        const queryParams = {
            data: JSON.stringify(modelParameters),
        };
        callApi(modelVersionKeys[modelVersion], key, queryParams)
            .then((response) => {
                resolve(response);
            })
            .catch((err) => reject(err));
    });
};

/*
call elec_correct, data:
{
	"properties": {
		"EC": 2.88
	},
	"custom_recipe": {
		"Cl": 1.01,
		"NO3": 29.52,
		"SO4": 1.36,
		"HCO3": 0.97,
		"H2PO4": 0.09,
		"NH4": 0.0,
		"K": 2.62,
		"Na": 1.99,
		"Mg": 5.21,
		"Ca": 8.71,
		"Fe": 0.2,
		"Mn": 0.0,
		"Zn": 0.3,
		"B": 8.0,
		"Cu": 0.0,
		"Mo": 1.0
	}
}
*/
/**
 * @typedef {Object.<string, number>} TElecCorrectResult
 *
 * @param {*} modelVersion
 * @param {*} parameters
 * @returns
 */
export const elecCorrect = (modelVersion, key, parameters) => {
    return new Promise((resolve, reject) => {
        const modelParameters = {
            properties: {
                EC: parseFloatInput(parameters.dropWaterValue),
            },
        };
        modelParameters.custom_recipe = extractParameter(
            parameters.ionValues,
            'elecCorrectRecipe'
        );
        // Do we even need to send feed_water ??
        modelParameters.feed_water = extractParameter(
            parameters.ionValues,
            'feedWaterAnalysis'
        );

        const queryParams = {
            data: JSON.stringify(modelParameters),
        };

        callApi('elec_correct', key, queryParams)
            .then((output) => {
                resolve(output);
            })
            .catch((err) => reject(err));
    });
};
